module.exports = __webpack_public_path__ + "img/maintenance.dbe635db.jpg";